// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ba4c3fd6","228":"1dfe9a84","304":"3b802eff","394":"d887490b","461":"25a7c34f","531":"2233df85","622":"661ff628","644":"b0e99530","740":"d3907233","804":"1d09dcdd","880":"0b7c74e6"}[chunkId] + ".chunk.js";
};